import { useRoutes } from "react-router-dom";
import pubilcRoutes from "./publicRoute";

const AppRoutes = () => {
  return useRoutes([pubilcRoutes]);
};

export default AppRoutes;
